import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import Navigator from "src/components/Navigator";
import ListDocuments from "../administration/documents/list";
import { useMemo } from "react";

const ViewDocuments = ({
    t
}) => {

    const documentsSettings = useMemo(() => {
        return {
            actions: {
                delete: false
            }
        }
    }, []);

    return (
        <div className='page-content'>
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator pageTitle={t('Documents')} translate={false} />
                    </Col>
                </Row>

                <ListDocuments settings={documentsSettings}/>   
            </Container>
        </div>
    )
};

const mapStatetoProps = (state) => {
    const { token, user } = state.Login;
    const organization = state.Organization;
    const App = state.App;
    return { organization, token, App, user };
};
  
export default withNamespaces()(
    withRouter(connect(mapStatetoProps, null)(ViewDocuments))
);